export default import.meta.ROLLDOWN_FILE_URL_2uCmcV94_u8wnIvjQZO3Iw